import { Injectable, inject } from '@angular/core';
import { IRole } from '../interfaces';
import { RolesManagementStore } from '../store/roles-management.store';

@Injectable({ providedIn: 'root' })
export class RoleService {
  private rolesStore = inject(RolesManagementStore);

  getRoleById(id: string): IRole | undefined {
    return this.rolesStore.entities().find((role) => role.id === id);
  }
}
